import { useEffect, useRef } from 'react'
import useEventTracking from '.'

const useDLProductKitViewed = () => {
  const trackEvent = useEventTracking();
  const isLoaded = useRef<boolean>(false)

  useEffect(() => {
    if (!isLoaded.current) {
      trackEvent('product_kit_viewed')
      isLoaded.current = true
    }
  }, [])
}

export default useDLProductKitViewed
